// LOAD ALL THE READ ONLY DATA
import { toast } from "react-toastify";
import { API_TARIFAS } from "../views/MainLayout/components/shared/services/tarifas";
import { setErrorMessage } from "../views/MainLayout/components/shared/helpers/functionalities";


const initialTarifas = []

export const tarifasFullfilledReducer = (state = initialTarifas, action) => {
    switch(action.type){
        case "tarifas/fullfilled": {            
            return action.payload;
        }
        default:
            return state
    }
}

export const fetchTarifas = () => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await API_TARIFAS.getTarifas()
        const data = await response.data;
        dispatch({ type: 'tarifas/fullfilled', payload: data })
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}